<template>
<div class="goods">
    <v-head :title="title"></v-head>
    <div class="banner">
        <van-swipe class="my-swipe"  indicator-color="white">
            <van-swipe-item v-for="item in 4" :key="item" >
                <div class="fontCent">
                <h3 class="small">
                准备和科技公司合作研发林学会数据智能平台准备和科技公司合作研发林学会数据智能平台
                </h3>
                <div>
                   <van-button hairline @click="votePage" round>我要投票</van-button>
                </div>
                </div>
            </van-swipe-item>
        </van-swipe>
    </div>
        <van-dropdown-menu>
            <van-dropdown-item v-model="value1" :options="option1" />
            <van-dropdown-item title="投票状态" v-model="value2" :options="option2" />
            <div @click="showa = true" class="dateBox">
                投票日期
                <b></b>
            </div>
            <div class="dateBox">最热</div>
        </van-dropdown-menu>
    <van-calendar v-model="showa" type="range" @confirm="onConfirm" color="#1989fa"  :min-date="minDate" :max-date="maxDate"/>
    <div class="liBox van-hairline--top">
        <ul>
            <li v-for="item in 8" :key="item">
               
                <h3>第一届茶会ACGN轮换投票活动-第一回漫画周</h3>
                <div>
                    <span>
                        <van-icon name="clock-o" />
                        2020-01-12&#32;至&#32;2020-02-01
                    </span>
                    <span>
                        <van-icon name="manager-o" />
                        管理员
                    </span>
                </div>
                <div>
                     <span style="color:#1989fa">
                        <van-icon name="label-o" />
                        选举投票
                    </span>
                </div>
                <p>内容：2月10日群内将发起海选投票链接，周三下午19:30投票截止并统计结果，进入前7名的作品将进入之后的决赛</p>
                <div style="margin:15px 0 0 0;" class="van-hairline--top">
                    <van-button plain type="text" size="large" @click="votePage">
                        去投票
                        <van-icon name="arrow" />
                    </van-button>
                </div>
            </li>
        </ul>
        <van-pagination 
            v-model="currentPage" 
            :page-count="12"
            mode="simple" 
        />
    </div>
</div>
</template>

<script type="text/javascript">
import {

} from "@/api/dictionary";
import vHead from "../../../components/meuHeader.vue";
import {
        NavBar,Button,Icon,Popup,Swipe,SwipeItem, Cell,CellGroup,Dialog,DropdownMenu,
        DropdownItem,Calendar, Pagination
    } from 'vant';
export default {
  data() {
    return {
        title:"投票选举",
        showa:false,
        value:'',
        value1: 0,
        value2: 'a',
        minDate: new Date(2010, 0, 1),
        maxDate: new Date(),
        currentPage: 1,
        option1: [
            { text: '全部投票', value: 0 },
            { text: '普通投票', value: 1 },
            { text: '选举投票', value: 2 },
        ],
        option2: [
            { text: '进行中', value: 'b' },
            { text: '已结束', value: 'c' },
        ],
    };
  },
  components: {
    vHead,
    [Button.name]:Button,
    [Icon.name]:Icon,
    [Popup.name]:Popup,
    [Swipe.name]:Swipe,
    [SwipeItem.name]:SwipeItem,
    [Cell.name]:Cell,
    [CellGroup.name]:CellGroup,
    [Dialog.name]:Dialog,
    [DropdownItem.name]:DropdownItem,
    [DropdownMenu.name]:DropdownMenu,
    [Calendar.name]:Calendar,
    [Pagination.name]:Pagination,
  },
  methods: {
    votePage(){
        this.$router.push({ name: "electionVote" }); 
    },
    onConfirm(date) {
      this.showa = false;
    },
  
  },
  mounted() {
    
  }
};
</script>

<style lang="less" scoped>
.banner{ margin-top:55px;}
/deep/.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  height: 260px !important;
  text-align: center;
  background-image: linear-gradient(90deg, #9c4dff 0%, #42a7ff 100%);
  display: flex;align-items: center; /*定义body的元素垂直居中*/
}
.fontCent{ width: 80%; margin:0 auto;}
.fontCent h3{ line-height: 36px; margin-bottom: 20px;
text-overflow: -o-ellipsis-lastline;
overflow: hidden;
text-overflow: ellipsis;
display: -webkit-box;
-webkit-line-clamp: 2;
-webkit-box-orient: vertical;}
/deep/.fontCent .van-button{ width: 120px; background:none; border-color: #fff; color: #fff; line-height: 20px;height: 36px;}
/deep/.fontCent .van-button span{ font-size:14px; }
.dateBox{ font-size:15px;display: -webkit-box; color: #323233;display: -webkit-flex;
    display: flex; -webkit-box-flex: 1; -webkit-flex: 1;
    flex: 1;-webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    min-width: 0;
    cursor: pointer;
    position: relative;
}
.dateBox b{
    position: absolute;
    top: 50%;
    right: 3px;
    margin-top: -0.13333rem;
    border: 0.08rem solid;
    border-color: transparent transparent currentColor currentColor;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg); 
    opacity: 0.8;
    content: '';
}
.liBox ul li{ padding: 30px 20px 0; color: #333; border-bottom: #f3f6fb solid 10px;}
.liBox li h3{ font-size:16px; color: #000;}
.liBox li>div{ margin: 10px 0 0 0; color: #999;}
.liBox li>div>span{ margin-right: 10px; position: relative; padding-left: 15px;font-size:12px; }
/deep/.liBox li>div>span .van-icon{ position:absolute; top: 1.5px; left: 0;}
.liBox li p{ font-size:14px;text-overflow: -o-ellipsis-lastline; line-height: 24px; margin: 8px 0; color: #333;
overflow: hidden;
text-overflow: ellipsis;
display: -webkit-box;
-webkit-line-clamp: 2;
-webkit-box-orient: vertical;}
/deep/.van-hairline--top-bottom{ border-width:inherit; border-bottom: inherit;}
/deep/.van-button--large{ height: 55px; position:relative; padding-right: 30px; }
/deep/.van-button--large .van-icon-arrow{ position: absolute; top: 41%; padding-left: 10px;font-size:12px;}
/deep/.van-pagination__item,/deep/.van-pagination__page-desc{ height: 50px; line-height: 50px;}
</style>